import React from 'react';
import { Box, BoxProps, Text } from 'rebass';

export type InlineNoticeProps = BoxProps;

const InlineNotice: React.FC<InlineNoticeProps> = ({ children, ...props }) => {
  return (
    <Box
      px={3}
      py={2}
      {...(props as any)}
      sx={{
        borderRadius: 'default',
        backgroundColor: 'tableAltRow',
        borderColor: 'tableBorder',
        borderStyle: 'solid',
        borderWidth: '1px',
        ...props.sx,
      }}
    >
      <Text fontSize={1} color="gray.600">
        {children}
      </Text>
    </Box>
  );
};

export default InlineNotice;
